var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8HeureDeLivraison(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 24 4 C 12.972292 4 4 12.972292 4 24 C 4 35.027708 12.972292 44 24 44 C 30.53585 44 36.348851 40.850837 40 35.988281 L 40 39.5 A 1.50015 1.50015 0 1 0 43 39.5 L 43 32.5 A 1.50015 1.50015 0 0 0 41.5 31 L 34.5 31 A 1.50015 1.50015 0 1 0 34.5 34 L 37.75 34 C 34.660921 38.241802 29.660824 41 24 41 C 14.593708 41 7 33.406292 7 24 C 7 14.593708 14.593708 7 24 7 C 33.406292 7 41 14.593708 41 24 L 41 24.5 A 1.50015 1.50015 0 1 0 44 24.5 L 44 24 C 44 12.972292 35.027708 4 24 4 z M 23.476562 11.978516 A 1.50015 1.50015 0 0 0 22 13.5 L 22 25.5 A 1.50015 1.50015 0 0 0 23.5 27 L 31.5 27 A 1.50015 1.50015 0 1 0 31.5 24 L 25 24 L 25 13.5 A 1.50015 1.50015 0 0 0 23.476562 11.978516 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8HeureDeLivraison);
export default __webpack_public_path__ + "static/media/icons8-heure-de-livraison.513d7f6a02dcb9ded6797d9d475ac893.svg";
export { ForwardRef as ReactComponent };